module.exports = __webpack_public_path__ + "img/i_es_m_03.bba4a29e.svg";